import { useQuery } from "@tanstack/react-query";
import { FlaskConical } from "lucide-react";
import { api } from "@/lib/api";

import { t } from "@/lib/i18n";
/** Testumgebung deutlich kennzeichnen – damit niemand Staging mit dem echten Portal verwechselt */
export function StagingBanner() {
  const q = useQuery({ queryKey: ["app-env"], queryFn: api.env, staleTime: Infinity, retry: false });
  if (q.data?.env !== "staging") return null;
  return (
    <div role="status" className="shrink-0 flex items-center justify-center gap-2 bg-warning text-white text-[12.5px] font-semibold h-7 px-3">
      <FlaskConical className="size-3.5" /> {t("Testumgebung (Staging) – keine echten Kunden, Lager nur Sandbox, Mails nur an @logiful.de")}
    </div>
  );
}
